module.exports = __webpack_public_path__ + "img/nikolai-lockertsen-transendence.b8007ff.jpg";